export default __webpack_public_path__ + "static/media/esg.5b785843.jpg";